<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      v-can="'customerpricelist.update'"
      class="item"
      effect="dark"
      content="Másolás"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-document-copy"
        @click="copyCustomerPriceList"
      />
    </el-tooltip>
    <el-tooltip
      v-can="'customerpricelist.view'"
      class="item"
      effect="dark"
      content="Letöltés"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-download"
        @click.stop="download"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'customerpricelist.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateCustomerPriceList"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
      v-can="'customerpricelist.delete'"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteCustomerPriceList()"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['customerPriceList'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false
      };
    },

    methods: {
      async deleteCustomerPriceList() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('customerPriceList/delete', this.customerPriceList.id);
          this.$store.dispatch('customerPriceList/fetchAll');
        } catch (e) {
        }
        this.deleteButtonLoader = false;
      },
      async updateCustomerPriceList() {
        this.$router.push('/data/customer-price-lists/update/' + this.customerPriceList.id);
      },
      async copyCustomerPriceList() {
        this.$router.push('/data/customer-price-lists/add/' + this.customerPriceList.id);
      },
      async download(e) {
        try {
          const excel = await axios({
            url: `api/customer-price-lists/${this.customerPriceList.id}/export`,
            method: 'POST',
            responseType: 'blob',
          });
          saveAs(excel, `customprices.xlsx`);
        } catch (e) {
          console.log(e)
        }
      },
    }
  };
</script>
